<div class="tournament-panel">

  <!-- ── Collapsible fleet + filters section ────────────────────────────── -->
  <div class="tourn-fleet-section" [class.collapsed]="!fleetSectionOpen">

    <div class="tourn-section-header" (click)="fleetSectionOpen = !fleetSectionOpen">
      <span class="tourn-section-title">
        Fleet &amp; Filters
        <span class="tourn-active-fleet" *ngIf="selectedAllianceName">— {{ selectedAllianceName }}</span>
      </span>
      <span class="tourn-section-chevron">{{ fleetSectionOpen ? '▲' : '▼' }}</span>
    </div>

    <div class="tourn-section-body" *ngIf="fleetSectionOpen">

      <!-- Search row -->
      <div class="tourn-fleet-search-row">
        <input class="tourn-fleet-input"
               type="text"
               placeholder="Search fleet by name…"
               [(ngModel)]="fleetSearchTerm"
               (ngModelChange)="onFleetSearchInput()"
               (keydown.enter)="searchTournamentFleet()"
               autocomplete="off" />
        <button class="tourn-fleet-btn" (click)="searchTournamentFleet()" [disabled]="fleetSearchLoading">
          <span *ngIf="!fleetSearchLoading">🔍</span>
          <span *ngIf="fleetSearchLoading" class="spinner-tiny"></span>
        </button>
      </div>
      <div class="tourn-search-error" *ngIf="fleetSearchError">{{ fleetSearchError }}</div>

      <!-- Favorites pills -->
      <div class="tourn-fav-pills" *ngIf="sharedFavorites.length > 0 && fleetSearchResults.length === 0">
        <button *ngFor="let f of sharedFavorites"
                class="tourn-fav-pill"
                [class.tourn-fav-pill-active]="f.allianceId === selectedAllianceId"
                (click)="selectFavoriteFleet(f)">
          <span class="tourn-pill-star favorited"
                (click)="$event.stopPropagation(); toggleFavorite(f.allianceId, f.allianceName)"
                title="Remove from favorites">★</span>
          {{ f.allianceName }}
        </button>
      </div>

      <!-- Search results -->
      <div class="tourn-fleet-results" *ngIf="fleetSearchResults.length > 0">
        <div class="tourn-fleet-result-row"
             *ngFor="let r of fleetSearchResults"
             (click)="selectTournamentFleet(r)">
          <span class="tourn-result-name">
            {{ r.allianceName }}
            <button class="tourn-result-star"
                    [class.favorited]="isFavorite(r.allianceId)"
                    (click)="$event.stopPropagation(); toggleFavorite(r.allianceId, r.allianceName)"
                    [title]="isFavorite(r.allianceId) ? 'Remove from favorites' : 'Add to favorites'">★</button>
          </span>
          <span class="tourn-result-meta" *ngIf="r.memberCount">{{ r.memberCount }}m</span>
        </div>
      </div>

      <!-- Filters row -->
      <div class="tourn-filters-row">
        <div class="control-group">
          <label class="control-label">Month</label>
          <select class="control-select" [(ngModel)]="selectedMonth">
            <option *ngFor="let m of months" [value]="m.value">{{ m.label }}</option>
          </select>
        </div>
        <div class="control-group">
          <label class="control-label">Year</label>
          <select class="control-select" [(ngModel)]="selectedYear">
            <option *ngFor="let y of yearOptions" [value]="y">{{ y }}</option>
          </select>
        </div>
        <div class="control-group">
          <label class="control-label">Days</label>
          <input class="control-input days-input"
                 type="number" min="1" max="7"
                 [(ngModel)]="numberOfDays"
                 (ngModelChange)="onNumberOfDaysChange()" />
        </div>
        <button class="refresh-btn"
                (click)="isUpcomingMonth ? loadForecast() : loadTournamentData()"
                [disabled]="isUpcomingMonth ? forecastLoading : loading">
          <span *ngIf="!isUpcomingMonth && !loading">↻ Load</span>
          <span *ngIf="isUpcomingMonth && !forecastLoading">⚡ Load Forecast</span>
          <span *ngIf="(!isUpcomingMonth && loading) || (isUpcomingMonth && forecastLoading)" class="spinner-tiny"></span>
        </button>
      </div>

    </div><!-- /tourn-section-body -->
  </div>

  <!-- ── Loading / Error ────────────────────────────────────────────────── -->
  <div *ngIf="loading" class="tourn-loading">
    <div class="spinner"></div>
    <span>Loading tournament data…</span>
  </div>

  <div *ngIf="!loading && error && !isUpcomingMonth" class="tourn-error">
    {{ error }}
  </div>

  <!-- ── Main content ───────────────────────────────────────────────────── -->
  <ng-container *ngIf="!loading && tournamentData && !isUpcomingMonth">

    <!-- ── Fleet header ─────────────────────────────────────────────────── -->
    <div class="fleet-header">
      <div class="fleet-name-row">
        <h2 class="fleet-name">{{ tournamentData.allianceName }}</h2>
        <span class="tourn-division-badge" *ngIf="tournamentData.allianceDivision">{{ fmtDivision(tournamentData.allianceDivision) }}</span>
        <button *ngIf="!isComparePanel"
                class="see-projection-btn"
                type="button"
                (click)="loadBacktest()"
                [disabled]="backtestLoading"
                title="Show what the forecast would have predicted for this month">
          <span *ngIf="!backtestLoading">⚡ See Projection</span>
          <span *ngIf="backtestLoading" class="spinner-tiny"></span>
        </button>
        <button class="fleet-name-star"
                type="button"
                [class.favorited]="isFavorite(selectedAllianceId)"
                (click)="toggleFavorite(selectedAllianceId, tournamentData.allianceName)"
                [title]="isFavorite(selectedAllianceId) ? 'Unfavorite fleet' : 'Favorite fleet'">
          ★
        </button>
      </div>
      <div class="period-label">
        Tournament — {{ months[tournamentData.month - 1].label }} {{ tournamentData.year }}
        &nbsp;({{ tournamentData.tournamentStart }} → {{ tournamentData.tournamentEnd }})
      </div>
    </div>

    <!-- ── Fleet summary grid ───────────────────────────────────────────── -->
    <div class="selected-day-banner" *ngIf="selectedDay">
      Showing Day {{ selectedDay.dayNumber }} detail — stats are now day-specific.
      <span class="day-delta-note" *ngIf="peerData">&#x2195; deltas show full-tournament comparison</span>
    </div>
    <div class="summary-grid">
      <div class="summary-card accent">
        <div class="summary-val">{{ displayTotalStars }}</div>
        <div class="peer-delta" *ngIf="peerData" [ngClass]="deltaClass(tournamentData.totalStars, peerData.totalStars)">{{ fmtDelta(tournamentData.totalStars, peerData.totalStars) }}</div>
        <div class="summary-lbl">{{ selectedDay ? 'Day Stars' : 'Total Stars' }}</div>
      </div>
      <div class="summary-card">
        <div class="summary-val">{{ displayAttacksAvailable }}</div>
        <div class="peer-delta" *ngIf="peerData" [ngClass]="deltaClass(tournamentData.attacksAvailable, peerData.attacksAvailable)">{{ fmtDelta(tournamentData.attacksAvailable, peerData.attacksAvailable) }}</div>
        <div class="summary-lbl">{{ selectedDay ? 'Day Attacks Available' : 'Attacks Available' }}</div>
      </div>
      <div class="summary-card">
        <div class="summary-val">{{ displayAttacksUsed }}</div>
        <div class="peer-delta" *ngIf="peerData" [ngClass]="deltaClass(tournamentData.attacksUsed, peerData.attacksUsed)">{{ fmtDelta(tournamentData.attacksUsed, peerData.attacksUsed) }}</div>
        <div class="summary-lbl">{{ selectedDay ? 'Day Attacks' : 'Attacks Used' }}</div>
      </div>
      <div class="summary-card" [class.low-pct]="displayPercentageUsed < 50">
        <div class="summary-val">{{ displayPercentageUsed | number:'1.0-2' }}%</div>
        <div class="peer-delta" *ngIf="peerData" [ngClass]="deltaClass(tournamentData.percentageUsed, peerData.percentageUsed)">{{ fmtDelta(tournamentData.percentageUsed, peerData.percentageUsed, 1) }}%</div>
        <div class="summary-lbl">{{ selectedDay ? 'Day % Used' : '% Used' }}</div>
      </div>
      <div class="summary-card">
        <div class="summary-val">{{ displayCard5Value }}</div>
        <div class="peer-delta" *ngIf="peerData && !selectedDay" [ngClass]="deltaClass(tournamentData.trophyMedian, peerData.trophyMedian)">{{ fmtDelta(tournamentData.trophyMedian, peerData.trophyMedian) }}</div>
        <div class="summary-lbl">{{ selectedDay ? 'Active Captains' : 'Trophy Median' }}</div>
      </div>
      <div class="summary-card">
        <div class="summary-val">{{ displayActiveCaptains }}</div>
        <div class="peer-delta" *ngIf="peerData" [ngClass]="deltaClass(peekActiveCaptains(tournamentData), peekActiveCaptains(peerData))">{{ fmtDelta(peekActiveCaptains(tournamentData), peekActiveCaptains(peerData)) }}</div>
        <div class="summary-lbl">Active Captains</div>
      </div>
      <div class="summary-card">
        <div class="summary-val">{{ displayAvgStarsPerActiveCaptain | number:'1.2-2' }}</div>
        <div class="peer-delta" *ngIf="peerData" [ngClass]="deltaClass(tournamentData.starsPerActiveCaptain, peerData.starsPerActiveCaptain)">{{ fmtDelta(tournamentData.starsPerActiveCaptain, peerData.starsPerActiveCaptain, 2) }}</div>
        <div class="summary-lbl">Stars / Active Captain</div>
      </div>
      <div class="summary-card">
        <div class="summary-val">
          {{ displayAvgTrophies | number:'1.1-1' }}
          <span class="summary-sub">({{ displayAvgMaxTrophies | number:'1.0-0' }})</span>
        </div>
        <div class="peer-delta" *ngIf="peerData" [ngClass]="deltaClass(tournamentData.trophyAvg, peerData.trophyAvg)">{{ fmtDelta(tournamentData.trophyAvg, peerData.trophyAvg, 1) }}</div>
        <div class="summary-lbl">Avg Trophies</div>
      </div>
      <div class="summary-card">
        <div class="summary-val">{{ displayAvgStarsPerAttack | number:'1.2-2' }}</div>
        <div class="peer-delta" *ngIf="peerData" [ngClass]="deltaClass(tournamentData.starsPerAttack, peerData.starsPerAttack)">{{ fmtDelta(tournamentData.starsPerAttack, peerData.starsPerAttack, 2) }}</div>
        <div class="summary-lbl">Stars / Attack</div>
      </div>
    </div>

    <!-- ── Chart + Top tables ────────────────────────────────────────────── -->
    <div class="chart-and-tables">

      <div class="chart-section">
        <h3 class="section-title">Stars totals per day</h3>
        <div class="chart-hint" *ngIf="!selectedDay">Click a bar to drill into that day</div>
        <div class="chart-hint selected-hint" *ngIf="selectedDay">
          Showing Day {{ selectedDay.dayNumber }} detail below &nbsp;
          <button class="clear-btn" (click)="clearDaySelection()">✕ Clear</button>
        </div>
        <div class="chart-hint missing-hint" *ngIf="missingSnapshotDays.length > 0">
          No snapshot data for day{{ missingSnapshotDays.length > 1 ? 's' : '' }}
          {{ missingSnapshotDays.join(', ') }} — grey bars = no fleet snapshot recorded.
        </div>
        <div class="chart-wrapper" (click)="onChartWrapperClick($event)" style="cursor:pointer">
          <canvas baseChart [data]="chartData" [options]="chartOptions" type="bar"></canvas>
        </div>
      </div>

      <div class="side-tables">
        <div class="side-table">
          <div class="side-table-header">
            <div class="toplist-menu-wrapper" (click)="$event.stopPropagation()">
              <button class="toplist-menu-btn" type="button" (click)="topListMenuOpen = !topListMenuOpen">☰</button>
              <div class="toplist-menu" *ngIf="topListMenuOpen">
                <button class="toplist-menu-item" [class.active]="topListType === 'topEarners'"       (click)="selectTopListType('topEarners')">Top Earners</button>
                <button class="toplist-menu-item" [class.active]="topListType === 'attacksMissed'"    (click)="selectTopListType('attacksMissed')">Attacks Missed</button>
                <button class="toplist-menu-item" [class.active]="topListType === 'starsPerAttack'"   (click)="selectTopListType('starsPerAttack')">Stars per Attack</button>
              </div>
            </div>
            <h3 class="section-title">{{ topListTitle }}</h3>
          </div>

          <table class="tourn-table">
            <thead><tr><th>Captain</th><th class="num-col">{{ topListValueHeader }}</th></tr></thead>
            <tbody>
              <ng-container [ngSwitch]="topListType">
                <ng-container *ngSwitchCase="'topEarners'">
                  <tr *ngFor="let e of topEarnerList; trackBy: trackById"
                      class="clickable-row" [class.selected-row]="selectedMember?.userId === e.userId"
                      (click)="selectMemberFromTopList(e.userId, e.userName)">
                    <td class="name-cell"><span class="own-badge" *ngIf="e.userId === session?.userId">★ </span>{{ e.userName }}</td>
                    <td class="num-col star-val">{{ e.totalStars }}</td>
                  </tr>
                </ng-container>
                <ng-container *ngSwitchCase="'attacksMissed'">
                  <tr *ngFor="let m of sortedMissedAttackList; trackBy: trackById"
                      class="clickable-row" [class.selected-row]="selectedMember?.userId === m.userId"
                      (click)="selectMemberFromTopList(m.userId, m.userName)">
                    <td class="name-cell"><span class="own-badge" *ngIf="m.userId === session?.userId">★ </span>{{ m.userName }}</td>
                    <td class="num-col missed-val" [ngClass]="missedAttacksClass(m)">{{ missedAttacksFor(m) }}</td>
                  </tr>
                </ng-container>
                <ng-container *ngSwitchCase="'starsPerAttack'">
                  <tr *ngFor="let s of starsPerAttackList; trackBy: trackById"
                      class="clickable-row" [class.selected-row]="selectedMember?.userId === s.userId"
                      (click)="selectMemberFromTopList(s.userId, s.userName)">
                    <td class="name-cell"><span class="own-badge" *ngIf="s.userId === session?.userId">★ </span>{{ s.userName }}</td>
                    <td class="num-col star-val">{{ s.starsPerAttack | number:'1.2-2' }}</td>
                  </tr>
                </ng-container>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- ── Day drill-down ──────────────────────────────────────────────── -->
    <div *ngIf="selectedDay" class="drill-panel day-drill">
      <div class="drill-header">
        <h3>Day {{ selectedDay.dayNumber }} — {{ selectedDay.date }}
          &nbsp;<span class="drill-sub">{{ selectedDay.totalStars }} stars · {{ selectedDay.totalAttacks }} attacks</span>
        </h3>
        <button class="clear-btn" (click)="clearDaySelection()">✕ Close</button>
      </div>
      <table class="tourn-table">
        <thead><tr><th>Captain</th><th class="num-col">Stars</th><th class="num-col">Attacks</th><th class="num-col">Trophies</th></tr></thead>
        <tbody>
          <tr *ngFor="let m of selectedDay.members; trackBy: trackById"
              class="clickable-row" [class.selected-row]="selectedMember?.userId === m.userId"
              (click)="selectMember(m)">
            <td class="name-cell">
              <span class="own-badge" *ngIf="m.userId === session?.userId">★ </span>{{ m.userName }}
              <span class="rank-badge">{{ m.membershipRank }}</span>
            </td>
            <td class="num-col star-val">{{ m.starsEarned }}</td>
            <td class="num-col">{{ m.attacksDone }}</td>
            <td class="num-col">{{ m.trophies | number }}</td>
          </tr>
          <tr *ngIf="selectedDay.members.length === 0">
            <td colspan="4" class="empty-row">No snapshot data for this day.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- ── Member drill-down ───────────────────────────────────────────── -->
    <div *ngIf="selectedMember" class="drill-panel member-drill">
      <div class="drill-header">
        <h3>
          <span class="own-badge" *ngIf="isOwnUser">★ </span>
          {{ selectedMember.userName }}
          <span class="drill-sub" *ngIf="selectedMember.membershipRank">{{ selectedMember.membershipRank }}</span>
        </h3>
        <button class="clear-btn" (click)="clearMemberSelection()">✕ Close</button>
      </div>

      <ng-container *ngIf="isOwnUser">
        <div *ngIf="memberBattlesLoading" class="member-loading">
          <div class="spinner-small"></div> Loading battle records…
        </div>
        <ng-container *ngIf="!memberBattlesLoading && memberBattlesLoaded">
          <div *ngIf="memberBattles.length === 0" class="empty-row">No tournament battle records found.</div>
          <table *ngIf="memberBattles.length > 0" class="tourn-table">
            <thead><tr><th>Result</th><th>Opponent</th><th class="num-col">Stars</th><th class="num-col">Trophies ±</th><th>Date</th></tr></thead>
            <tbody>
              <tr *ngFor="let b of memberBattles"
                  [class.battle-win]="battleResult(b) === 'win'"
                  [class.battle-loss]="battleResult(b) === 'loss'">
                <td><span class="result-badge" [class.win]="battleResult(b) === 'win'">{{ battleResult(b) === 'win' ? 'W' : 'L' }}</span></td>
                <td class="name-cell">{{ battleOpponentName(b) }}</td>
                <td class="num-col star-val">{{ b.starsWon }}</td>
                <td class="num-col" [class.pos]="b.winTrophyResult > 0">{{ b.winTrophyResult > 0 ? '+' : '' }}{{ b.winTrophyResult }}</td>
                <td class="date-cell">{{ formatBattleDate(b.battleDate) }}</td>
              </tr>
            </tbody>
          </table>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="!isOwnUser">
        <div class="other-member-note">Individual battle records are only available for your own account.</div>
        <table class="tourn-table">
          <thead><tr><th>Day</th><th>Date</th><th class="num-col">Stars</th><th class="num-col">Attacks</th></tr></thead>
          <tbody>
            <tr *ngFor="let day of memberDaySummary(selectedMember.userId)">
              <td>Day {{ day.dayNumber }}</td>
              <td>{{ day.date }}</td>
              <td class="num-col star-val">{{ day.stars }}</td>
              <td class="num-col">{{ day.attacks }}</td>
            </tr>
          </tbody>
        </table>
      </ng-container>
    </div>

    <!-- ── Projection error (primary panel only) ────────────────────────── -->
    <div *ngIf="backtestError && !backtestLoading && !isComparePanel" class="tourn-error">{{ backtestError }}</div>

  </ng-container>

  <!-- ── Standalone projection view (compare panel) ────────────────────── -->
  <ng-container *ngIf="isComparePanel && backtestData">
    <div class="backtest-panel">
      <div class="forecast-header">
        <div class="forecast-title-block">
          <h3 class="section-title">Projection vs Actual</h3>
          <div class="forecast-fleet-name">
            {{ backtestData.allianceName }} — {{ months[backtestData.forecastMonth - 1].label }} {{ backtestData.forecastYear }}
          </div>
        </div>
        <span class="forecast-period">Based on {{ backtestData.priorTournamentStart }} → {{ backtestData.priorTournamentEnd }}</span>
        <button class="clear-btn" (click)="backtestData = null">✕ Close</button>
      </div>

      <div class="forecast-summary-row">
        <div class="forecast-stat">
          <span class="forecast-stat-val">{{ backtestData.predictedTotalStars }}</span>
          <span class="forecast-stat-lbl">Predicted Stars</span>
        </div>
        <div class="forecast-stat">
          <span class="forecast-stat-val">{{ backtestData.actualTotalStars }}</span>
          <span class="forecast-stat-lbl">Actual Stars</span>
        </div>
        <div class="forecast-stat">
          <span class="forecast-stat-val"
                [ngClass]="backtestTotalDiff > 0 ? 'diff-pos' : backtestTotalDiff < 0 ? 'diff-neg' : 'diff-zero'">
            {{ backtestTotalDiff > 0 ? '+' : '' }}{{ backtestTotalDiff }}
          </span>
          <span class="forecast-stat-lbl">Difference</span>
        </div>
        <div class="forecast-stat">
          <span class="forecast-stat-val">{{ backtestData.memberCount }}</span>
          <span class="forecast-stat-range">+{{ backtestData.newMemberCount }} new</span>
          <span class="forecast-stat-lbl">Members</span>
        </div>
      </div>

      <table class="tourn-table forecast-table">
        <thead>
          <tr>
            <th>Captain</th>
            <th class="num-col">Prior Stars</th>
            <th class="num-col">Predicted</th>
            <th class="num-col">Actual</th>
            <th class="num-col">Diff</th>
            <th>Notes</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let m of backtestData.members">
            <tr [class.forecast-new-member]="m.isNewMember"
                [class.forecast-row-expanded]="expandedForecastMemberId === m.userId"
                class="forecast-member-row clickable-row"
                (click)="toggleForecastMember(m.userId)">
              <td class="name-cell">
                <span class="own-badge" *ngIf="m.userId === session?.userId">★ </span>
                {{ m.userName }}
                <span class="new-member-badge" *ngIf="m.isNewMember" title="Joined since last tournament">new</span>
              </td>
              <td class="num-col">{{ m.priorStars }}</td>
              <td class="num-col"><span class="star-val">{{ m.predictedStars }}</span></td>
              <td class="num-col"><span class="star-val">{{ m.actualStars }}</span></td>
              <td class="num-col">
                <span [ngClass]="m.starsDiff > 0 ? 'diff-pos' : m.starsDiff < 0 ? 'diff-neg' : 'diff-zero'">
                  {{ m.starsDiff > 0 ? '+' : '' }}{{ m.starsDiff }}
                </span>
              </td>
              <td class="forecast-note-cell">
                <span class="confidence-badge" [ngClass]="forecastConfidenceClass(m.confidence)">{{ m.confidence }}</span>
                <span class="forecast-reason" [title]="m.adjustmentReason">{{ m.adjustmentFactor < 1 ? '⬇ adj' : '' }}</span>
              </td>
            </tr>
            <tr *ngIf="expandedForecastMemberId === m.userId" class="forecast-history-row">
              <td colspan="6">
                <div class="forecast-history-flyout">
                  <div *ngIf="forecastMemberHistoryLoading" class="spinner-tiny"></div>
                  <ng-container *ngIf="!forecastMemberHistoryLoading">
                    <ng-container *ngIf="forecastMemberTournHistory(m.userId).length > 0; else noBacktestHistory">
                      <table class="forecast-history-table">
                        <thead><tr><th class="month-col">Month</th><th>Fleet</th><th>Division</th><th class="num-col">Stars</th><th class="num-col">Attacks</th></tr></thead>
                        <tbody>
                          <tr *ngFor="let h of forecastMemberTournHistory(m.userId)">
                            <td class="month-col">{{ fmtForecastMonth(h.month) }}</td>
                            <td class="fleet-col">{{ h.fleetName }}</td>
                            <td class="division-col">{{ h.division }}</td>
                            <td class="num-col star-val">{{ h.stars }}</td>
                            <td class="num-col">{{ h.attacks }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </ng-container>
                    <ng-template #noBacktestHistory>
                      <span class="forecast-no-history">No tournament history found</span>
                    </ng-template>
                  </ng-container>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </ng-container>

  <!-- ── Forecast panel (upcoming month only) ─────────────────────────── -->
  <div class="forecast-panel" *ngIf="!loading && isUpcomingMonth && selectedAllianceId">
    <div class="forecast-header">
      <div class="forecast-title-block">
        <h3 class="section-title">Tournament Forecast</h3>
        <div class="forecast-fleet-name" *ngIf="selectedAllianceName">
          {{ selectedAllianceName }}
          <span class="forecast-division-badge" *ngIf="forecastData?.fleetCurrentDivision">{{ fmtDivision(forecastData!.fleetCurrentDivision) }}</span>
        </div>
      </div>
      <span class="forecast-period" *ngIf="forecastData">
        Based on {{ forecastData.priorTournamentStart }} → {{ forecastData.priorTournamentEnd }}
      </span>
    </div>

    <div *ngIf="forecastError" class="tourn-error">{{ forecastError }}</div>

    <ng-container *ngIf="forecastData && !forecastLoading">
      <div class="forecast-summary-row">
        <div class="forecast-stat">
          <span class="forecast-stat-val">{{ forecastData.predictedTotalStars }}</span>
          <span class="forecast-stat-range">{{ forecastPredictedStarsLow }}–{{ forecastPredictedStarsHigh }}</span>
          <span class="forecast-stat-lbl">Predicted Stars</span>
          <div class="peer-delta" *ngIf="peerForecastData" [ngClass]="deltaClass(forecastData.predictedTotalStars, peerForecastData.predictedTotalStars)">{{ fmtDelta(forecastData.predictedTotalStars, peerForecastData.predictedTotalStars) }}</div>
        </div>
        <div class="forecast-stat">
          <span class="forecast-stat-val">{{ forecastData.memberCount }}</span>
          <span class="forecast-stat-lbl">Members</span>
          <div class="peer-delta" *ngIf="peerForecastData" [ngClass]="deltaClass(forecastData.memberCount, peerForecastData.memberCount)">{{ fmtDelta(forecastData.memberCount, peerForecastData.memberCount) }}</div>
        </div>
        <div class="forecast-stat">
          <span class="forecast-stat-val accent">{{ forecastData.newMemberCount }}</span>
          <span class="forecast-stat-lbl">New Members</span>
          <div class="peer-delta" *ngIf="peerForecastData" [ngClass]="deltaClass(forecastData.newMemberCount, peerForecastData.newMemberCount)">{{ fmtDelta(forecastData.newMemberCount, peerForecastData.newMemberCount) }}</div>
        </div>
        <div class="forecast-stat">
          <span class="forecast-stat-val">{{ forecastData.fleetPriorAvgStars }}</span>
          <span class="forecast-stat-lbl">Fleet Prior Avg</span>
          <div class="peer-delta" *ngIf="peerForecastData" [ngClass]="deltaClass(forecastData.fleetPriorAvgStars, peerForecastData.fleetPriorAvgStars)">{{ fmtDelta(forecastData.fleetPriorAvgStars, peerForecastData.fleetPriorAvgStars) }}</div>
        </div>
      </div>

      <table class="tourn-table forecast-table">
        <thead>
          <tr>
            <th>Captain</th>
            <th class="num-col">Prior Stars</th>
            <th class="num-col">Predicted</th>
            <th class="num-col">Attacks</th>
            <th>Notes</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let m of forecastData.members">
            <tr [class.forecast-new-member]="m.isNewMember"
                [class.forecast-row-expanded]="expandedForecastMemberId === m.userId"
                class="forecast-member-row clickable-row"
                (click)="toggleForecastMember(m.userId)">
              <td class="name-cell">
                <span class="own-badge" *ngIf="m.userId === session?.userId">★ </span>
                {{ m.userName }}
                <span class="new-member-badge" *ngIf="m.isNewMember" title="Joined since last tournament">new</span>
              </td>
              <td class="num-col">{{ m.priorStars }}</td>
              <td class="num-col">
                <span class="star-val">{{ m.predictedStars }}</span>
                <span class="forecast-range-cell">{{ m.predictedStarsLow }}–{{ m.predictedStarsHigh }}</span>
              </td>
              <td class="num-col">{{ m.priorAttacks }}</td>
              <td class="forecast-note-cell">
                <span class="confidence-badge" [ngClass]="forecastConfidenceClass(m.confidence)">{{ m.confidence }}</span>
                <span class="forecast-reason" [title]="m.adjustmentReason">{{ m.adjustmentFactor < 1 ? '⬇ adj' : '' }}</span>
              </td>
            </tr>
            <tr *ngIf="expandedForecastMemberId === m.userId" class="forecast-history-row">
              <td colspan="5">
                <div class="forecast-history-flyout">
                  <div *ngIf="forecastMemberHistoryLoading" class="spinner-tiny"></div>
                  <ng-container *ngIf="!forecastMemberHistoryLoading">
                    <ng-container *ngIf="forecastMemberTournHistory(m.userId).length > 0; else noHistory">
                      <table class="forecast-history-table">
                        <thead><tr><th class="month-col">Month</th><th>Fleet</th><th>Division</th><th class="num-col">Stars</th><th class="num-col">Attacks</th></tr></thead>
                        <tbody>
                          <tr *ngFor="let h of forecastMemberTournHistory(m.userId)">
                            <td class="month-col">{{ fmtForecastMonth(h.month) }}</td>
                            <td class="fleet-col">{{ h.fleetName }}</td>
                            <td class="division-col">{{ h.division }}</td>
                            <td class="num-col star-val">{{ h.stars }}</td>
                            <td class="num-col">{{ h.attacks }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </ng-container>
                    <ng-template #noHistory>
                      <span class="forecast-no-history">No tournament history found</span>
                    </ng-template>
                  </ng-container>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </ng-container>
  </div>

</div>
